module.exports = __webpack_public_path__ + "img/KikkomanNameLogo.9c372764.png";